<template>
    <div class="scanner-item" :class="{ 'printable': isPrintable, 'scanning': !isPrintable && itemsToScan > 0, 'is-scanning': isScanning }">
        <!-- Progress Bar Background -->
        <div class="progress-background">
            <div class="progress-fill" :style="{ width: progressPercentage + '%' }"></div>
        </div>
        
        <!-- Content Overlay -->
        <div class="scanner-content">
            <div class="scan-display">
                <div class="scan-count">
                    <span class="scanned">{{ scannedItems }}</span>
                    <span class="separator">/</span>
                    <span class="total">{{ itemsToScan }}</span>
                </div>
                <div class="scan-label">Artikel gescannt</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ScannerItem',
    props: {
        scannedItems: {
            type: Number,
            required: true
        },
        itemsToScan: {
            type: Number,
            required: true
        },
        isPrintable: {
            type: Boolean,
            default: false
        },
        isScanning: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        progressPercentage() {
            if (this.itemsToScan === 0) return 0;
            return Math.min(100, (this.scannedItems / this.itemsToScan) * 100);
        }
    }
}
</script>

<style scoped>
.scanner-item {
    position: relative;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    padding: 10px 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    overflow: hidden;
    min-height: 50px;
}

.scanner-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.scanner-item.scanning {
    border-color: #1976d2;
}

.scanner-item.printable {
    border-color: #4caf50;
    animation: printablePulse 2s ease-in-out infinite;
}

.scanner-item.is-scanning {
    border-color: #ff9800;
}

.scanner-item.is-scanning .scan-count .scanned {
    animation: scanningPulse 0.8s ease-in-out infinite;
}

.progress-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(240, 240, 240, 0.8);
    border-radius: 10px;
}

.progress-fill {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    background: linear-gradient(135deg, #1976d2, #1565c0);
    border-radius: 10px;
    transition: width 0.5s ease;
    opacity: 0.15;
}

.scanner-item.printable .progress-fill {
    background: linear-gradient(135deg, #4caf50, #45a049);
}

.scanner-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 100%;
}

.scan-display {
    text-align: center;
}

.scan-count {
    font-family: 'Monaco', 'Consolas', monospace;
    font-size: 18px;
    font-weight: 700;
    color: #333;
    line-height: 1;
}

.scanned {
    color: #1976d2;
}

.separator {
    color: #666;
    margin: 0 4px;
}

.total {
    color: #666;
}

.scan-label {
    font-size: 9px;
    color: #666;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 2px;
}

.scanner-status {
    display: flex;
    align-items: center;
}

.status-chip {
    font-weight: 500 !important;
    font-size: 10px !important;
}

/* Printable state styling */
.scanner-item.printable .scan-count .scanned {
    color: #4caf50;
}

/* Animations */
@keyframes printablePulse {
    0%, 100% { border-color: #4caf50; }
    50% { border-color: #81c784; }
}

@keyframes scanningPulse {
    0%, 100% { color: #1976d2; }
    50% { color: #ff9800; }
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .scanner-item {
        padding: 12px;
        min-height: 70px;
    }
    
    .scan-count {
        font-size: 20px;
    }
    
    .scan-label {
        font-size: 10px;
    }
}

@media (max-width: 480px) {
    .scanner-item {
        padding: 10px;
        min-height: 60px;
    }
    
    .scan-count {
        font-size: 18px;
    }
    
    .scan-label {
        font-size: 9px;
    }
    
    .status-chip {
        font-size: 9px !important;
    }
}
</style>